<template>
	<div class="role-page full-height">
		<table-con>
			<div slot="breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/home' }">{{ $t('notFound.home') }}</el-breadcrumb-item>
					<el-breadcrumb-item>{{ $t('BuddleOrder.BuddleOrder19') }}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div slot="search">
				<el-row class="search-row">
					<el-col :span="6" class="display-row">
						<div class="query-title1">{{ $t('BuddleOrder.BuddleOrder15') }}:</div>
						<div class="flex1">
							<el-input :placeholder="$t('orderList.orderList3')" clearable v-model="queryInfo.tongkunNo" size="small" @keyup.enter.native="searchList"> </el-input>
						</div>
					</el-col>
					<el-col :span="6" class="display-row">
						<div class="query-title1">{{ $t('mail.mailTo') }}:</div>
						<div class="flex1">
							<el-input :placeholder="$t('orderList.orderList3')" clearable v-model="queryInfo.receiverName" size="small" @keyup.enter.native="searchList"> </el-input>
						</div>
					</el-col>
					<el-col :span="6" class="display-row">
						<div class="query-title1">{{ $t('wzbg.wz1') }}:</div>
						<div class="flex1">
							<el-date-picker
								clearable
								v-model="queryInfo.createTimeStart"
								type="date"
								size="small"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								:placeholder="$t('BuddleOrderDetail.BuddleOrderDetail2')"
							>
							</el-date-picker>
						</div>
					</el-col>
					<el-col :span="6" class="display-row">
						<div class="query-title1">{{ $t('wzbg.wz2') }}:</div>
						<div class="flex1">
							<el-date-picker
								clearable
								v-model="queryInfo.createTimeEnd"
								type="date"
								size="small"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								:placeholder="$t('BuddleOrderDetail.BuddleOrderDetail2')"
							>
							</el-date-picker>
						</div>
					</el-col>
				</el-row>
				<el-row class="search-row">
					<el-col :span="6" class="display-row">
						<div class="query-title1">{{ $t('BuddleOrderDetail.BuddleOrderDetail3') }}:</div>
						<div class="flex1">
							<el-date-picker
								clearable
								v-model="queryInfo.completeTimeStart"
								type="date"
								size="small"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								:placeholder="$t('BuddleOrderDetail.BuddleOrderDetail2')"
							>
							</el-date-picker>
						</div>
					</el-col>
					<el-col :span="6" class="display-row">
						<div class="query-title1">{{ $t('BuddleOrderDetail.BuddleOrderDetail4') }}:</div>
						<div class="flex1">
							<el-date-picker
								clearable
								v-model="queryInfo.completeTimeEnd"
								type="date"
								size="small"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								:placeholder="$t('BuddleOrderDetail.BuddleOrderDetail2')"
							>
							</el-date-picker>
						</div>
					</el-col>
					<el-col :span="6" class="display-row">
						<div class="query-title1">{{ $t('orderList.orderList4') }}:</div>
						<div class="flex1">
							<el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.trackingNumberJpn" size="small" @keyup.enter.native="searchList"> </el-input>
						</div>
					</el-col>
				</el-row>
				<el-row class="search-row">
					<el-col :span="18" class="display-row">
						<el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 0 }" @click="quickSearchList('', (index = 0))">{{ $t('wzbg.wz19') }}</el-button>
						<el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 1 }" @click="quickSearchList('5', (index = 1))"
							>{{ $t('orderList.orderList8') }}<span class="lx-red">({{ orderData.waitWarehouseCount }})</span></el-button
						>
						<el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 2 }" @click="quickSearchList('3', (index = 2))"
							>{{ $t('BuddleOrder.BuddleOrder1') }}<span class="lx-red">({{ orderData.arrivedCount }})</span></el-button
						>
						<el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 3 }" @click="quickSearchList('2', (index = 3))"
							>{{ $t('orderList.orderList98') }}<span class="lx-red">({{ orderData.applySendCount }})</span></el-button
						>
						<el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 4 }" @click="quickSearchList('4', (index = 4))"
							>{{ $t('orderList.orderList108') }}<span class="lx-red">({{ orderData.packedCount }})</span></el-button
						>
						<el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 5 }" @click="quickSearchList('6', (index = 5))"
							>{{ $t('orderList.orderList11') }}<span class="lx-red">({{ orderData.waitPayCount }})</span></el-button
						>
						<el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 6 }" @click="quickSearchList('1', (index = 6))"
							>{{ $t('orderList.orderList72') }}<span class="lx-red">({{ orderData.sendingCount }})</span></el-button
						>
						<el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 7 }" @click="quickSearchList('7', (index = 7))">{{ $t('orderList.orderList73') }}</el-button>
						<el-button class="search-btn btn-white" :class="{ lxBtnGreenDeep: curIndex === 8 }" @click="quickSearchList('9', (index = 8))">{{ $t('status.status4') }}</el-button>
					</el-col>
					<el-col :span="6" class="display-row">
						<div style="text-align: right; width: 100%; padding-right: 10px; floate: right">
							<el-button class="search-btn btn-gray" @click="queryInfoClear">{{ $t('reset') }}</el-button>
							<el-button class="search-btn btn-blue" @click="searchList">{{ $t('query') }}</el-button>
						</div>
					</el-col>
				</el-row>
			</div>
			<div slot="table" class="full-height display-col">
				<el-table :data="recordList" border style="width: 100%" height="550" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle">
					<el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="50"></el-table-column>
					<el-table-column :label="$t('OrderBill.OrderBill15')" align="center" width="110">
						<template v-slot="scope">
							<div class="btn-row">
								<el-button style="width: 100px" class="list-btn-four btn-blue" @click="toOrderDetail(scope.row)">
									{{ $t('BuddleOrder.BuddleOrder17') }}
								</el-button>
							</div>
							<div class="btn-row">
								<el-button v-if="scope.row.status === '5' || scope.row.status === '3'" class="list-btn-four btn-blue" @click="sendAction(scope.row)">{{ $t('BuddleOrder.BuddleOrder16') }} </el-button>
							</div>
							<div class="btn-row">
								<el-button v-if="scope.row.status === '6'" class="list-btn-four btn-red" @click="payBills(scope.row)">{{ $t('BuddleOrder.BuddleOrder24') }} </el-button>
							</div>
							<div class="btn-row">
								<el-button v-if="scope.row.status === '1' || scope.row.status === '7'" class="list-btn-four btn-red" @click="payBills(scope.row)">{{ $t('orderList.orderList21') }} </el-button>
							</div>
							<div class="btn-row">
								<!-- v-if="(scope.row.status==='5'&&scope.row.orderCount>1) || (scope.row.status==='3'&&scope.row.orderCount>1) || (scope.row.status==='2'&&scope.row.orderCount>1)" -->
								<el-button
									style="width: 100px"
									v-if="scope.row.status === '5' || scope.row.status === '3' || scope.row.status === '2'"
									class="list-btn-four btn-green"
									@click.native="handleOpen(scope.row.id)"
									>{{ $t('BuddleOrder.BuddleOrder25') }}
								</el-button>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="tongkunNo" align="center" :label="$t('BuddleOrder.BuddleOrder15')"> </el-table-column>
					<el-table-column prop="createTime" sortable align="center" :index="indexMethod" :label="$t('BuddleOrder.BuddleOrder14')">
						<template v-slot="scope">
							{{ scope.row.createTime | dateFormatToDay }}
						</template>
					</el-table-column>
					<el-table-column prop="status" :index="indexMethod" align="center" :label="$t('BuddleOrder.BuddleOrder13')">
						<template v-slot="scope">
							{{ tongkunStatusShow(scope.row.status) }}
						</template>
					</el-table-column>
					<el-table-column prop="status" sortable :index="indexMethod" align="center" :label="$t('BuddleOrder.BuddleOrder26')">
						<template v-slot="scope">
							<div class="btn-row">
								{{ scope.row.trackingNumberJpn }}
							</div>
							<div class="btn-row overflowDot" :title="scope.row.sagawaState">
								{{ scope.row.logisticsState }}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="completeTime" sortable align="center" :index="indexMethod" :label="$t('BuddleOrder.BuddleOrder12')">
						<template v-slot="scope">
							{{ scope.row.completeTime | dateFormatToDay }}
						</template>
					</el-table-column>
					<el-table-column prop="receiverName" :label="$t('BuddleOrder.BuddleOrder11')">
						<template v-slot="scope">
							<div>
								<span>{{ $t('mail.mailTo') }}：</span>
								<span>{{ scope.row.receiverName }}</span>
							</div>
							<div>
								<span>{{ $t('BuddleOrder.BuddleOrder10') }}：</span>
								<span>{{ scope.row.receiverAddress }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="orderCount" align="center" :index="indexMethod" sortable width="160" :label="$t('BuddleOrder.BuddleOrder9')">
						<template v-slot="scope">
							<div>
								<span>{{ $t('BuddleOrder.BuddleOrder9') }}：</span>
								<span>{{ scope.row.orderCount }}</span>
							</div>
							<div>
								<span>{{ $t('BuddleOrder.BuddleOrder8') }}：</span>
								<span>{{ scope.row.arrivalCount }}</span>
							</div>
						</template>
					</el-table-column>
					<!--          <el-table-column-->
					<!--              prop="orderCount"-->
					<!--              sortable-->
					<!--              :index="indexMethod"-->
					<!--              label="同捆数">-->
					<!--          </el-table-column>-->
					<!--          -->
					<!--          <el-table-column-->
					<!--              prop="arrivalCount"-->
					<!--              sortable-->
					<!--              :index="indexMethod"-->
					<!--              label="同捆到货数">-->
					<!--          </el-table-column>-->
					<el-table-column prop="orderId" :label="$t('BuddleOrder.BuddleOrder7')" align="center" min-width="100"> </el-table-column>
				</el-table>
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="queryInfo.pageNum"
					:page-sizes="[5, 10, 20, 50, 100, 200]"
					:pager-count="5"
					:page-size="queryInfo.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</table-con>
		<lx-select-goods :id="id" :visible.sync="isVisiable" :selectList="renderWaybillDetailList" @confirm="onSelectGoods"></lx-select-goods>
	</div>
</template>

<script>
import tableCon from '../../../views/tableContainer';
import LxSelectGoods from '@/components/LxSelectGoods/index';
export default {
	components: { tableCon, LxSelectGoods },
	data() {
		return {
			isVisiable: false, // 拆单
			curIndex: 0, // 默认选中第0个
			waybillDetailList: [], // 选择的商品
			renderWaybillDetailList: [],
			// delFlag, // 删除标识
			queryInfo: {
				id: '',
				userId: '1',
				tongkunNo: '',
				receiverName: '',
				status: '',
				createTimeStart: '',
				createTimeEnd: '',
				completeTimeStart: '',
				completeTimeEnd: '',
				trackingNumberJpn: '',
				pageSize: 10,
				pageNum: 1
			},
			id: -1, //同捆id
			orderData: {
				totalCount: 0,
				sendingCount: 0,
				applySendCount: 0,
				packedCount: 0,
				waitWarehouseCount: 0,
				arrivedCount: 0,
				waitPayCount: 0,
				sendCount: 0
			},
			// orderDateRangeValue: [],
			orderDetailValue: {
				id: '',
				status: ''
			},
			recordList: [],
			total: 0,
			orderDateRangeValue2: []
		};
	},
	methods: {
		indexMethod(index) {
			return (this.pageNum - 1) * this.pageSize + index + 1;
		},
		orderDateRange2() {},
		handleOpen(id) {
			this.isVisiable = true;
			this.id = id;
		},
		handleSizeChange(newSize) {
			this.queryInfo.pageSize = newSize;
			this.getrecordList();
		},
		//正常发送
		sendAction(row) {
			this.sendDeal(row);
		},
		handleCurrentChange(newPage) {
			this.queryInfo.pageNum = newPage;
			this.getrecordList();
		},
		orderDateRange() {},
		searchList() {
			//查询
			this.queryInfo.pageNum = 1;
			this.getrecordList();
			this.getStatisticalNum();
		},
		quickSearchList(val, index) {
			this.curIndex = index;
			this.queryInfo.pageNum = 1;
			this.queryInfo.status = val;
			this.getrecordList();
			this.getStatisticalNum();
		},
		async getrecordList() {
			const { data: res } = await this.$http.get('/tongkun/list', { params: this.queryInfo });
			this.recordList = res.data.list;
			this.total = res.data.total;
		},
		async getStatisticalNum() {
			//获取
			const { data: res } = await this.$http.get('/tongkun/tongKunCount', { params: this.queryInfo });
			this.orderData = res.data;
		},
		toOrderDetail(row) {
			this.$router.push({
				name: 'buddleOrderDetail',
				query: {
					id: row.id
				}
			});
		},
		sendDeal(row) {
			this.$confirm(this.$t('BuddleOrder.BuddleOrder5'), this.$t('BuddleOrder.BuddleOrder6'), {
				confirmButtonText: this.$t('submit'),
				confirmButtonClass: 'form-btn btn-blue',
				cancelButtonText: this.$t('cancel'),
				cancelButtonClass: 'form-btn btn-gray',
				type: 'warning'
			})
				.then(async () => {
					this.orderDetailValue.id = row.id;
					const { data: res } = await this.$http.post(`tongkun/applySend/`, this.orderDetailValue);
					if (res.code !== 200) {
						this.$message.error(res.message);
					} else {
						this.$message({
							type: 'success',
							message: this.$t('BuddleOrder.BuddleOrder4')
						});
						await this.getrecordList();
						this.getStatisticalNum();
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: this.$t('BuddleOrder.BuddleOrder3')
					});
				});
		},
		queryInfoClear() {
			//清空
			this.queryInfo = {
				createTimeStart: '',
				createTimeEnd: '',
				completeTimeStart: '',
				completeTimeEnd: '',
				status: '',
				receiverName: '',
				tongkunNo: '',
				userId: '1',
				pageSize: 10,
				pageNum: 1
			};
			// this.orderDateRangeValue = [];
			// this.orderDateRangeValue2 = [];
		},
		// 选择商品回调
		onSelectGoods() {
			this.getStatisticalNum();
			this.getrecordList();
		},
		// 支付账单
		payBills(row) {
			this.$router.push({
				name: 'payBills',
				query: {
					id: row.tongkunNo
				}
			});
		},
		tongkunStatusShow(status) {
			switch (status) {
				case '1':
					return this.$t('orderList.orderList72');
					break;
				case '2':
					return this.$t('orderList.orderList33');
					break;
				case '3':
					return this.$t('BuddleOrder.BuddleOrder1');
					break;
				case '4':
					return this.$t('orderList.orderList108');
					break;
				case '5':
					return this.$t('orderList.orderList8');
					break;
				case '6':
					return this.$t('orderList.orderList11');
					break;
				case '7':
					return this.$t('orderList.orderList73');
					break;
				case '9':
					return this.$t('status.status4');
					break;
			}
		}
	},
	watch: {
		//监听时间选择器绑定值变化
		// orderDateRangeValue() {
		//   //解决时间选择器清空后 绑定值为null问题
		//   if (!this.orderDateRangeValue) {
		//     this.orderDateRangeValue = [];
		//     this.queryInfo.createTimeStart = '';
		//     this.queryInfo.createTimeEnd = '';
		//   } else {
		//     if (this.orderDateRangeValue.length > 0) {
		//       this.queryInfo.createTimeStart = this.orderDateRangeValue[0];
		//       this.queryInfo.createTimeEnd = this.orderDateRangeValue[1];
		//     }
		//   }
		// },
		// orderDateRangeValue2() {
		//   //解决时间选择器清空后 绑定值为null问题
		//   if (!this.orderDateRangeValue2) {
		//     this.orderDateRangeValue2 = [];
		//     this.queryInfo.completeTimeStart = '';
		//     this.queryInfo.completeTimeEnd = '';
		//   } else {
		//     if (this.orderDateRangeValue2.length > 0) {
		//       this.queryInfo.completeTimeStart = this.orderDateRangeValue2[0];
		//       this.queryInfo.completeTimeEnd = this.orderDateRangeValue2[1];
		//     }
		//   }
		//
		// }
	},
	created() {
		this.getStatisticalNum();
		this.getrecordList();
	}
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
	height: 60px !important;
}

.el-table .el-button--small {
	padding: 4px 10px;
}
.query-title1 {
	/* padding-right: 10px; */
	height: 30px;
	line-height: 30px;
	width: 125px;
	padding: 0 10px 0 10px;
	text-align: right;
}
</style>
